<template>
  <div class="mt-1">
    <b-modal
      size="md"
      :visible="isShowCheckCodeModal"
      title="Kiểm tra voucher code"
      centered
      cancel-variant="outline-secondary"
      :hide-footer="true"
      @hide="hideMethod"
      @change="(val) => $emit('update:is-show-check-code-modal', val)"
    >
      <b-overlay
        :show="loading"
        rounded="sm"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
      >
        <div v-if="step === 1">
          <b-form-group label="Tìm kiếm">
            <b-form-input
              placeholder="Nhập voucher code"
              v-model="voucherCode"
              @input="resetVoucherInfo"
              autofocus
            />
          </b-form-group>
          <div class="mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="w-full"
              :loading="loading"
              @click="handleCheckVoucherCode"
            >
              Kiểm tra
            </b-button>
          </div>
        </div>

        <div
          v-if="step === 2 && infoVoucher.group"
          class="d-flex flex-col items-center justify-center text-center"
        >
          <table class="w-full table table-striped">
            <thead>
              <tr>
                <td colspan="2">
                  <h4 class="text-center mb-0" :class="voucherStatusClass">
                    {{ voucherStatusLabel }}
                  </h4>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-left text-nowrap px-0">Chương trình</td>
                <td class="text-right pl-1 pr-0">
                  <span v-if="infoVoucher.campaign">{{
                    infoVoucher.campaign.name
                  }}</span>
                </td>
              </tr>
              <tr>
                <td class="text-left text-nowrap px-0">Nhóm</td>
                <td class="text-right pl-1 pr-0">
                  <span v-if="infoVoucher.group">{{
                    infoVoucher.group.name
                  }}</span>
                </td>
              </tr>
              <tr>
                <td class="text-left text-nowrap px-0">Thời hạn</td>
                <td class="text-right pl-1 pr-0">{{ voucherDate }}</td>
              </tr>
              <tr>
                <td class="text-left text-nowrap px-0">Mã voucher</td>
                <td class="text-right pl-1 pr-0">{{ voucherCode }}</td>
              </tr>
              <tr>
                <td class="text-left text-nowrap px-0">Giá trị</td>
                <td class="text-right pl-1 pr-0 text-danger font-bold">
                  {{ voucherValue }}
                </td>
              </tr>
              <tr
                v-if="infoVoucher.group && infoVoucher.group.voucher_type === 2"
              >
                <td class="text-left text-nowrap px-0">Giá trị tối đa</td>
                <td class="text-right pl-1 pr-0 text-danger font-bold">
                  {{ voucherMaxValue }}
                </td>
              </tr>
            </tbody>
          </table>

          <b-button
            v-if="
              !infoVoucher.is_redeemed &&
              !voucherExpired &&
              !voucherNotStarted &&
              !voucherCanceled
            "
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="w-full"
            :loading="loading"
            @click="handleRedeemVoucherCode"
          >
            Sử dụng
          </b-button>
          <b-button
            v-else
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="w-full"
            @click="resetForm"
          >
            Quay lại
          </b-button>
        </div>

        <div
          v-if="step === 3"
          class="d-flex flex-col items-center justify-center"
        >
          <IconSuccess />
          <h4 class="text-success text-center">Sử dụng voucher thành công</h4>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import appUtils from "@/utils/appUtils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BButton,
  BFormGroup,
  BFormInput,
  BModal,
  BOverlay,
  VBModal,
} from "bootstrap-vue";
import moment from "moment";
import Vue from "vue";
import Ripple from "vue-ripple-directive";
import IconSuccess from "./IconSuccess";

export default {
  components: {
    BModal,
    BButton,
    BOverlay,
    BFormGroup,
    BFormInput,
    IconSuccess,
  },
  directives: { "b-modal": VBModal, Ripple },
  props: { isShowCheckCodeModal: { type: Boolean, required: true } },
  data() {
    return {
      appUtils,
      step: 1,
      infoVoucher: {},
      voucherCode: "",
      loading: false,
      redeemVoucherCodeSuccess: false,
    };
  },
  watch: {
    isShowCheckCodeModal(newVal) {
      if (newVal) this.resetForm();
    },
  },
  computed: {
    voucherStatusLabel() {
      if (this.infoVoucher.is_redeemed) return "Voucher đã sử dụng";
      if (this.voucherExpired) return "Voucher đã hết hạn";
      if (this.voucherCanceled) return "Voucher đã huỷ bỏ";
      if (this.voucherNotStarted) return "Chương trình chưa bắt đầu";
      return "Voucher hợp lệ";
    },
    voucherStatusClass() {
      return this.infoVoucher.is_redeemed ||
        this.voucherExpired ||
        this.voucherCanceled ||
        this.voucherNotStarted
        ? "text-danger"
        : "text-success";
    },
    voucherCanceled() {
      return this.infoVoucher?.group?.status === 2;
    },
    voucherExpired() {
      return (
        (this.infoVoucher?.group?.start_date &&
          this.infoVoucher?.group?.end_date &&
          this.infoVoucher?.group?.end_date < Date.now()) ||
        this.infoVoucher.campaign?.end_date < Date.now()
      );
    },
    voucherNotStarted() {
      return (
        (this.infoVoucher?.group?.start_date &&
          this.infoVoucher?.group?.end_date &&
          this.infoVoucher?.group?.start_date > Date.now()) ||
        this.infoVoucher.campaign?.start_date > Date.now()
      );
    },
    voucherExpiredText() {
      return `Chương trình khuyến mãi đã kết thúc vào ngày ${moment(
        this.infoVoucher.campaign.end_date
      ).format("DD/MM/YYYY")}`;
    },
    voucherNotStartedText() {
      return `Chương trình khuyến mãi bắt đầu từ ngày ${moment(
        this.infoVoucher.campaign.start_date
      ).format("DD/MM/YYYY")}`;
    },
    voucherValue() {
      if (this.infoVoucher?.group?.voucher_type === 1) {
        return `${appUtils.numberFormat(
          this.infoVoucher?.group?.voucher_value
        )} VNĐ`;
      }
      return `${this.infoVoucher?.group?.voucher_value}%`;
    },
    voucherMaxValue() {
      if (this.infoVoucher?.group?.voucher_type === 2) {
        return `${appUtils.numberFormat(
          this.infoVoucher?.group?.max_voucher_value
        )} VNĐ`;
      }
    },
    voucherDate() {
      if (
        this.infoVoucher?.group?.start_date &&
        this.infoVoucher?.group?.end_date
      ) {
        return `${moment(this.infoVoucher?.group?.start_date).format(
          "DD/MM/YYYY"
        )} - ${moment(this.infoVoucher?.group?.end_date).format("DD/MM/YYYY")}`;
      }
      return `${moment(this.infoVoucher?.campaign?.start_date).format(
        "DD/MM/YYYY"
      )} - ${moment(this.infoVoucher?.campaign?.end_date).format(
        "DD/MM/YYYY"
      )}`;
    },
  },
  methods: {
    hideMethod() {
      this.$emit("closeModalCheckCode");
    },
    resetVoucherInfo() {
      this.infoVoucher = {};
    },
    resetForm() {
      this.step = 1;
      this.voucherCode = "";
      this.infoVoucher = {};
    },
    async handleCheckVoucherCode() {
      this.loading = true;
      try {
        const userData = appUtils.getLocalUser();
        const org_id = userData?.supplierInfo?.org_id;
        const { data } = await Vue.prototype.$rf
          .getRequest("CampaignRequest")
          .checkVoucherCode(this.voucherCode, { org_id });
        this.infoVoucher = data;
        this.step = 2;
      } catch (error) {
        this.showToastError("Voucher code không hợp lệ");
      } finally {
        this.loading = false;
      }
    },
    async handleRedeemVoucherCode() {
      try {
        await Vue.prototype.$rf
          .getRequest("CampaignRequest")
          .redeemVoucherCode(this.infoVoucher.id);
        this.step = 3;
      } catch (error) {
        this.showToastError("Lỗi khi sử dụng voucher");
      }
    },
    showToastError(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: message,
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.collapsible {
  overflow: hidden;
  height: 0;
  transition: height 100ms ease;
}

.collapsible.is-open {
  height: auto;
}

.content {
  padding: 10px;
}
</style>
